import axios from 'axios';

// Créez un nouvel objet de cancel token
const cancelToken = axios.CancelToken;
let source = null;

// Fonction pour annuler toutes les requêtes en cours
export function cancelAllRequests() {
    if (source) {
        source.cancel('Operation canceled by the user.');
    }
    source = cancelToken.source();
    axios.defaults.cancelToken = source.token;

    console.info('All requests canceled');
}
